import React from 'react';

export default () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 0H6.75V6.75H0V0ZM11.625 0C13.5 0 15 1.5 15 3.375C15 5.25 13.5 6.75 11.625 6.75C9.75 6.75 8.25 5.25 8.25 3.375C8.25 1.5 9.75 0 11.625 0ZM3.375 9L6.75 15H0L3.375 9ZM12.75 11.25H15V12.75H12.75V15H11.25V12.75H9V11.25H11.25V9H12.75V11.25Z" fill="currentColor"/>
  </svg>
);
